import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { SpinnerCitoPlus } from "jsx/components/CitoPlus/components/loadingLogo";
import { isAuthenticated } from "store/selectors/AuthSelectors";

const ProtectedRoute = ({ children }) => {
  const isUserAuthenticated = useSelector(isAuthenticated);
  const showLoading = useSelector((state) => state.auth.showLoading);

  if (showLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <SpinnerCitoPlus />
      </div>
    );
  }

  return isUserAuthenticated ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
